
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/transportbil/mercedes-sprinter",
      function () {
        return require("private-next-pages/wheels/transportbil/mercedes-sprinter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/transportbil/mercedes-sprinter"])
      });
    }
  